module.exports = __webpack_public_path__ + "static/media/icon-character__margaret-thatcher.6beb1396.svg";